export default __webpack_public_path__ + "images/Q3.73d2adb.png";